import { Injectable } from '@angular/core';
import { UnhandledError, HandledError } from '@cordic/request';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ChatMailErrorHandler, ErrorTypes } from '@cordic/chatmail-web';

@Injectable({
  providedIn: 'root'
})
export class ChatMailErrorHandlingService extends ChatMailErrorHandler {

  constructor(public translateService: TranslateService)
  {
    super();
  }

  public handleGeneric(error: HttpErrorResponse | any): UnhandledError
  {
    let unhandledError = new UnhandledError(error);

    unhandledError.translatableMessage = this.translateService.get('IDS_ERROR_GENERIC');

    return unhandledError;
  }

  handleSpecific(errorCode: number, errorType: ErrorTypes): HandledError;
  handleSpecific(error: string): HandledError<string>;

  public handleSpecific(errorCode: any, errorType?: any, response?): HandledError | HandledError<string>
  {
    let handledError = null;

    if (typeof errorCode === 'string')
    {
      let errorString = this.translateService.get('IDS_ERROR_GENERIC');

      console.log('Server string error response = ' + errorCode);

      errorCode = errorCode.trim();

      if (errorCode.length > 0)
      {
        errorString = of(errorCode);
      }

      handledError = new HandledError<string>(errorCode, errorString);
    }
    else
    {
      let errorObs = this.translateService.get('IDS_ERROR_GENERIC');

      switch (errorType)
      {
        case (ErrorTypes.OperatorChatErrors):
        {
          break;
        }
      }

      handledError = new HandledError(errorCode, errorObs);
    }

    return handledError;
  }




}
